import { CSSProperties,useEffect, useState } from 'react';

import Checkbox from '../checkbox/checkbox';
import styles from './index.module.sass';

interface checkboxData {
  id: string;
  isChecked: boolean;
  value: string;
  disabled: boolean;
}

interface CheckboxGroup {
  label?: string;
  data: checkboxData[];
  name: string;
  onChange: (value: checkboxData[]) => {};
  style: CSSProperties;
  column: number;
  gap: number;
}

const CheckboxGroup = ({
  label,
  data,
  name,
  onChange,
  style,
  column,
  gap,
}: CheckboxGroup) => {
  const [checkboxData, setCheckboxData] = useState(data);

  useEffect(() => {
    setCheckboxData(data);
  }, [data]);

  return (
    <>
      {label && <div className={styles.label}>{label}</div>}
      <div
        className={styles['checkbox-group']}
        style={{ gridTemplateColumns: `repeat(${column},1fr)`, gap }}
      >
        {checkboxData.map((d) => {
          return (
            <Checkbox
              key={d.id}
              isChecked={d.isChecked}
              id={d.id}
              value={d.value}
              name={name}
              onChange={(e: any) => {
                const newData = checkboxData.map((data) => {
                  if (data.id === d.id) {
                    return { ...data, isChecked: e };
                  } else {
                    return data;
                  }
                });

                setCheckboxData(newData);
                onChange(newData);
              }}
              style={style}
            />
          );
        })}
      </div>
    </>
  );
};

export default CheckboxGroup;
